<template>
  <div class="discount-details__pdf" v-if="discount.pdfData" v-loading="!pdf.loading">
    <transition name="fade">
      <div class="folder-expand position-fixed" v-if="expand">
        <button class="close action position-absolute m-2" @click="closeExpand">
          <img src="@/assets/images/pdf/close.svg" alt="Sluiten">
        </button>
        <div class="folder-nav d-flex position-absolute">
          <button class="action  m-2" @click="nextPrev(-1)">
            <img src="@/assets/images/pdf/arrow-left.svg" alt="Vorige">
          </button>
          <span class="font-montserrat align-self-center p-2">{{ pdf.page }} / {{ pdf.pages ? pdf.pages : '~' }}</span>
          <button class="action  m-2" @click="nextPrev(1)">
            <img src="@/assets/images/pdf/arrow-right.svg" alt="Volgende">
          </button>
          <button class="action  m-2 ml-auto" @click="closeExpand">
            <img src="@/assets/images/pdf/expand_close.svg" alt="Sluiten">
          </button>
        </div>
        <pdf
          :src="pdf.data"
          :page="pdf.page"
          v-if="pdf.loading"
          :class="{ 'next-page': nextPage }"
          :style="`width: ${folderWidth}`"
          :resize="true"
          class="folder__inner position-absolute"
        />
      </div>
    </transition>
    <div class="folder position-relative">
      <div class="folder-nav d-flex position-absolute">
        <button class="action  m-2" @click="nextPrev(-1)">
          <img src="@/assets/images/pdf/arrow-left.svg" alt="Vorige">
        </button>
        <span class="font-montserrat align-self-center p-2">{{ pdf.page }} / {{ pdf.pages ? pdf.pages : '~' }}</span>
        <button class="action  m-2" @click="nextPrev(1)">
          <img src="@/assets/images/pdf/arrow-right.svg" alt="Volgende">
        </button>
        <button class="close action  m-2 ml-auto" @click="activateExpand">
          <img src="@/assets/images/pdf/expand.svg" alt="Vergroten">
        </button>
      </div>
      <div @click="activateExpand">
        <pdf
          :src="pdf.data"
          :page="pdf.page"
          v-if="pdf.loading"
          :resize="true"
          :class="{ 'next-page': nextPage }"
          class="folder__inner mx-auto w-80 w-md-40"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'pdfvuer'

export default {
  name: 'DiscountPdf',
  props: {
    discount: Object,
    pdf: Object
  },
  components: {
    pdf
  },
  data () {
    return {
      expand: false,
      folderWidth: '100%',
      nextPage: false
    }
  },
  methods: {
    nextPrev (input) {
      const goPage = () => {
        this.nextPage = true
        this.pdf.beforePage += input
        this.setFolderWidth(this.pdf.beforePage)
        setTimeout(() => {
          this.pdf.page = this.pdf.beforePage
          this.nextPage = false
        }, 500)
      }
      if (input === -1) {
        if (this.pdf.beforePage > 1) {
          goPage()
        }
      } else {
        if (this.pdf.beforePage < this.pdf.pages) {
          goPage()
        }
      }
    },
    activateExpand () {
      this.expand = true
      this.$store.commit('setDefaultLayout', false)
      this.setFolderWidth(this.pdf.page)

      window.addEventListener('resize', () => {
        this.setFolderWidth(this.pdf.page)
      })
    },
    closeExpand () {
      this.expand = false
      this.$store.commit('setDefaultLayout', true)
    },
    setFolderWidth (page) {
      const pageHeight = window.innerHeight
      const pageWidht = window.innerWidth
      this.pdf.loadedData.getPage(page).then(folder => {
        const width = folder.getViewport(1).width
        const height = folder.getViewport(1).height
        const aspect = width / height
        this.folderWidth = Math.min(pageWidht, (aspect * pageHeight)) + 'px'
      })
    }
  }
}
</script>
